var React = require('react');
var {Link} = require('react-router');
var CategoryRow = React.createClass({
    render: function() {
        return (
            <Link href="#/quiz">
                {this.props.category.category}
            </Link>


            );
    }
});

module.exports = CategoryRow;


// WEBPACK FOOTER //
// ./react/app/components/CategoryRow.jsx